// Make a basic component with Redwing logo at the top and then a block of lorem ipsum

import { Box, Container, Heading, Image, Link, Text } from "@chakra-ui/react";
import usePageMeta from "../../../shared/hooks/usePageMeta";

const Eula = () => {
  usePageMeta(
    "End User License Agreement - Redwing",
    "The end user license agreement for the Redwing comic reading orders app.",
    "/eula"
  );
  return (
    <Container maxW="container.xl" py={8}>
      <Image
        src="/images/logo-512.png"
        maxH="100px"
        alt="Redwing Logo"
        mb={8}
      />
      <Box>
        <Heading as="h1" id="end-user-license-agreement" mb={4}>
          END USER LICENSE AGREEMENT
        </Heading>
        <Text mb={4}>
          <strong>Last updated</strong> <strong>June 28, 2022</strong>
        </Text>
        <Text mb={4}>
          Redwing is licensed to You (End-User) by Redwing Tech Ltd, located and
          registered at 32 Christiemiller avenue, Edinburgh, Scotland EH7 6ST,
          Scotland (&quot;<strong>Licensor</strong>&quot;), for use only under
          the terms of this License Agreement.
        </Text>
        <Text mb={4}>
          By downloading the Licensed Application from Apple&#39;s software
          distribution platform (&quot;App Store&quot;) and Google&#39;s
          software distribution platform (&quot;Play Store&quot;), and any
          update thereto (as permitted by this License Agreement), You indicate
          that You agree to be bound by all of the terms and conditions of this
          License Agreement, and that You accept this License Agreement. App
          Store and Play Store are referred to in this License Agreement as
          &quot;<strong>Services</strong>.&quot;
        </Text>
        <Text mb={4}>
          The parties of this License Agreement acknowledge that the Services
          are not a Party to this License Agreement and are not bound by any
          provisions or obligations with regard to the Licensed Application,
          such as warranty, liability, maintenance and support thereof. Redwing
          Tech Ltd, not the Services, is solely responsible for the Licensed
          Application and the content thereof.
        </Text>
        <Text mb={4}>
          This License Agreement may not provide for usage rules for the
          Licensed Application that are in conflict with the latest{" "}
          <Link
            href="https://www.apple.com/legal/internet-services/itunes/us/terms.html"
            color="blue.500"
          >
            Apple Media Services Terms and Conditions
          </Link>{" "}
          and{" "}
          <Link
            href="https://play.google.com/intl/en_US/about/play-terms/"
            color="blue.500"
          >
            Google Play Terms of Service
          </Link>{" "}
          (&quot;<strong>Usage Rules</strong>&quot;). Redwing Tech Ltd
          acknowledges that it had the opportunity to review the Usage Rules and
          this License Agreement is not conflicting with them.
        </Text>
        <Text mb={4}>
          Redwing when purchased or downloaded through the Services, is licensed
          to You for use only under the terms of this License Agreement. The
          Licensor reserves all rights not expressly granted to You. Redwing is
          to be used on devices that operate with Apple&#39;s operating systems
          (&quot;iOS&quot; and &quot;Mac OS&quot;) or Google&#39;s operating
          system (&quot;Android&quot;).
        </Text>
        <Heading as="h2" mb={4}>
          <strong>TABLE OF CONTENTS</strong>
        </Heading>
        <Text mb={2}>
          <Link href="#application" color="blue.500">
            1. THE APPLICATION
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#scope" color="blue.500">
            2. SCOPE OF LICENSE
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#requirements" color="blue.500">
            3. TECHNICAL REQUIREMENTS
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#nosupport" color="blue.500">
            4. NO MAINTENANCE AND SUPPORT
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#datause" color="blue.500">
            5. USE OF DATA
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#ugc" color="blue.500">
            6. USER-GENERATED CONTRIBUTIONS
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#contribution" color="blue.500">
            7. CONTRIBUTION LICENSE
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#liability" color="blue.500">
            8. LIABILITY
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#warranty" color="blue.500">
            9. WARRANTY
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#productclaims" color="blue.500">
            10. PRODUCT CLAIMS
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#compliance" color="blue.500">
            11. LEGAL COMPLIANCE
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#contact" color="blue.500">
            12. CONTACT INFORMATION
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#termination" color="blue.500">
            13. TERMINATION
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#thirdparty" color="blue.500">
            14. THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#ipr" color="blue.500">
            15. INTELLECTUAL PROPERTY RIGHTS
          </Link>
        </Text>
        <Text mb={2}>
          <Link href="#law" color="blue.500">
            16. APPLICABLE LAW
          </Link>
        </Text>
        <Text mb={4}>
          <Link href="#misc" color="blue.500">
            17. MISCELLANEOUS
          </Link>
        </Text>
        <Heading as="h2" mb={4}>
          <strong>1. THE APPLICATION</strong>
        </Heading>
        <Text mb={4}>
          Redwing (&quot;<strong>Licensed Application</strong>&quot;) is a piece
          of software created to Redwing was created to help comic readers
          navigate through their reading. — and customized for iOS and Android
          mobile devices (&quot;<strong>Devices</strong>&quot;). It is used to
          Redwing is a companion app that provides the reading order for your
          favorite comics and allows you to keep track of your progress..
        </Text>
        <Text mb={4}>
          The Licensed Application is not tailored to comply with
          industry-specific regulations (Health Insurance Portability and
          Accountability Act (HIPAA), Federal Information Security Management
          Act (FISMA), etc.), so if your interactions would be subjected to such
          laws, you may not use this Licensed Application. You may not use the
          Licensed Application in a way that would violate the
          Gramm-Leach-Bliley Act (GLBA).
        </Text>
        <Heading as="h2" mb={4}>
          <strong>2. SCOPE OF LICENSE</strong>
        </Heading>
        <Text mb={4}>
          2.1 You are given a non-transferable, non-exclusive, non-sublicensable
          license to install and use the Licensed Application on any Devices
          that You (End-User) own or control and as permitted by the Usage
          Rules, with the exception that such Licensed Application may be
          accessed and used by other accounts associated with You (End-User, The
          Purchaser) via Family Sharing or volume purchasing.
        </Text>
        <Text mb={4}>
          2.2 This license will also govern any updates of the Licensed
          Application provided by Licensor that replace, repair, and/or
          supplement the first Licensed Application, unless a separate license
          is provided for such update, in which case the terms of that new
          license will govern.
        </Text>
        <Text mb={4}>
          2.3 You may not share or make the Licensed Application available to
          third parties (unless to the degree allowed by the Usage Rules, and
          with Redwing Tech Ltd&#39;s prior written consent), sell, rent, lend,
          lease or otherwise redistribute the Licensed Application.
        </Text>
        <Text mb={4}>
          2.4 You may not reverse engineer, translate, disassemble, integrate,
          decompile, remove, modify, combine, create derivative works or updates
          of, adapt, or attempt to derive the source code of the Licensed
          Application, or any part thereof (except with Redwing Tech Ltd&#39;s
          prior written consent).
        </Text>
        <Text mb={4}>
          2.5 You may not copy (excluding when expressly authorized by this
          license and the Usage Rules) or alter the Licensed Application or
          portions thereof. You may create and store copies only on devices that
          You own or control for backup keeping under the terms of this license,
          the Usage Rules, and any other terms and conditions that apply to the
          device or software used. You may not remove any intellectual property
          notices. You acknowledge that no unauthorized third parties may gain
          access to these copies at any time. If you sell your Devices to a
          third party, you must remove the Licensed Application from the Devices
          before doing so.
        </Text>
        <Text mb={4}>
          2.6 Violations of the obligations mentioned above, as well as the
          attempt of such infringement, may be subject to prosecution and
          damages.
        </Text>
        <Text mb={4}>
          2.7 Licensor reserves the right to modify the terms and conditions of
          licensing.
        </Text>
        <Text mb={4}>
          2.8 Nothing in this license should be interpreted to restrict
          third-party terms. When using the Licensed Application, You must
          ensure that You comply with applicable third-party terms and
          conditions.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>3. TECHNICAL REQUIREMENTS</strong>
        </Heading>
        <Text mb={4}>
          3.1 Licensor attempts to keep the Licensed Application updated so that
          it complies with modified/new versions of the firmware and new
          hardware. You are not granted rights to claim such an update.
        </Text>
        <Text mb={4}>
          3.2 You acknowledge that it is Your responsibility to confirm and
          determine that the app end-user device on which You intend to use the
          Licensed Application satisfies the technical specifications mentioned
          above.
        </Text>
        <Text mb={4}>
          3.3 Licensor reserves the right to modify the technical specifications
          as it sees appropriate at any time.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>4. NO MAINTENANCE OR SUPPORT</strong>
        </Heading>
        <Text mb={4}>
          4.1 Redwing Tech Ltd is not obligated, expressed or implied, to
          provide any maintenance, technical or other support for the Licensed
          Application.
        </Text>
        <Text mb={4}>
          4.2 Redwing Tech Ltd and the End-User acknowledge that the Services
          have no obligation whatsoever to furnish any maintenance and support
          services with respect to the Licensed Application.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>5. USE OF DATA</strong>
        </Heading>
        <Text mb={4}>
          You acknowledge that Licensor will be able to access and adjust Your
          downloaded Licensed Application content and Your personal information,
          and that Licensor&#39;s use of such material and information is
          subject to Your legal agreements with Licensor and Licensor&#39;s
          privacy policy:{" "}
          <Link href="https://redwing.app/terms" color="blue.500">
            https://redwing.app/terms
          </Link>
          .
        </Text>
        <Text mb={4}>
          You acknowledge that the Licensor may periodically collect and use
          technical data and related information about your device, system, and
          application software, and peripherals, offer product support,
          facilitate the software updates, and for purposes of providing other
          services to you (if any) related to the Licensed Application. Licensor
          may also use this information to improve its products or to provide
          services or technologies to you, as long as it is in a form that does
          not personally identify you.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>6. USER-GENERATED CONTRIBUTIONS</strong>
        </Heading>
        <Text mb={4}>
          The Licensed Application may invite you to chat, contribute to, or
          participate in blogs, message boards, online forums, and other
          functionality, and may provide you with the opportunity to create,
          submit, post, display, transmit, perform, publish, distribute, or
          broadcast content and materials to us or in the Licensed Application,
          including but not limited to text, writings, video, audio,
          photographs, graphics, comments, suggestions, or personal information
          or other material (collectively, &quot;Contributions&quot;).
          Contributions may be viewable by other users of the Licensed
          Application and through third-party websites or applications. As such,
          any Contributions you transmit may be treated as non-confidential and
          non-proprietary. When you create or make available any Contributions,
          you thereby represent and warrant that:
        </Text>
        <Text mb={4}>
          1. The creation, distribution, transmission, public display, or
          performance, and the accessing, downloading, or copying of your
          Contributions do not and will not infringe the proprietary rights,
          including but not limited to the copyright, patent, trademark, trade
          secret, or moral rights of any third party.
        </Text>
        <Text mb={4}>
          2. You are the creator and owner of or have the necessary licenses,
          rights, consents, releases, and permissions to use and to authorize
          us, the Licensed Application, and other users of the Licensed
          Application to use your Contributions in any manner contemplated by
          the Licensed Application and this License Agreement.
        </Text>
        <Text mb={4}>
          3. You have the written consent, release, and/or permission of each
          and every identifiable individual person in your Contributions to use
          the name or likeness or each and every such identifiable individual
          person to enable inclusion and use of your Contributions in any manner
          contemplated by the Licensed Application and this License Agreement.
        </Text>
        <Text mb={4}>
          4. Your Contributions are not false, inaccurate, or misleading.
        </Text>
        <Text mb={4}>
          5. Your Contributions are not unsolicited or unauthorized advertising,
          promotional materials, pyramid schemes, chain letters, spam, mass
          mailings, or other forms of solicitation.
        </Text>
        <Text mb={4}>
          6. Your Contributions are not obscene, lewd, lascivious, filthy,
          violent, harassing, libelous, slanderous, or otherwise objectionable
          (as determined by us).
        </Text>
        <Text mb={4}>
          7. Your Contributions do not ridicule, mock, disparage, intimidate, or
          abuse anyone.
        </Text>
        <Text mb={4}>
          8. Your Contributions are not used to harass or threaten (in the legal
          sense of those terms) any other person and to promote violence against
          a specific person or class of people.
        </Text>
        <Text mb={4}>
          9. Your Contributions do not violate any applicable law, regulation,
          or rule.
        </Text>
        <Text mb={4}>
          10. Your Contributions do not violate the privacy or publicity rights
          of any third party.
        </Text>
        <Text mb={4}>
          11. Your Contributions do not violate any applicable law concerning
          child pornography, or otherwise intended to protect the health or
          well-being of minors.
        </Text>
        <Text mb={4}>
          12. Your Contributions do not include any offensive comments that are
          connected to race, national origin, gender, sexual preference, or
          physical handicap.
        </Text>
        <Text mb={4}>
          13. Your Contributions do not otherwise violate, or link to material
          that violates, any provision of this License Agreement, or any
          applicable law or regulation.
        </Text>
        <Text mb={4}>
          Any use of the Licensed Application in violation of the foregoing
          violates this License Agreement and may result in, among other things,
          termination or suspension of your rights to use the Licensed
          Application.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>7. CONTRIBUTION LICENSE</strong>
        </Heading>
        <Text mb={4}>
          By posting your Contributions to any part of the Licensed Application
          or making Contributions accessible to the Licensed Application by
          linking your account from the Licensed Application to any of your
          social networking accounts, you automatically grant, and you represent
          and warrant that you have the right to grant, to us an unrestricted,
          unlimited, irrevocable, perpetual, non-exclusive, transferable,
          royalty-free, fully-paid, worldwide right, and license to host, use
          copy, reproduce, disclose, sell, resell, publish, broad cast, retitle,
          archive, store, cache, publicly display, reformat, translate,
          transmit, excerpt (in whole or in part), and distribute such
          Contributions (including, without limitation, your image and voice)
          for any purpose, commercial advertising, or otherwise, and to prepare
          derivative works of, or incorporate in other works, such as
          Contributions, and grant and authorize sublicenses of the foregoing.
          The use and distribution may occur in any media formats and through
          any media channels.
        </Text>
        <Text mb={4}>
          This license will apply to any form, media, or technology now known or
          hereafter developed, and includes our use of your name, company name,
          and franchise name, as applicable, and any of the trademarks, service
          marks, trade names, logos, and personal and commercial images you
          provide. You waive all moral rights in your Contributions, and you
          warrant that moral rights have not otherwise been asserted in your
          Contributions.
        </Text>
        <Text mb={4}>
          We do not assert any ownership over your Contributions. You retain
          full ownership of all of your Contributions and any intellectual
          property rights or other proprietary rights associated with your
          Contributions. We are not liable for any statements or representations
          in your Contributions provided by you in any area in the Licensed
          Application. You are solely responsible for your Contributions to the
          Licensed Application and you expressly agree to exonerate us from any
          and all responsibility and to refrain from any legal action against us
          regarding your Contributions.
        </Text>
        <Text mb={4}>
          We have the right, in our sole and absolute discretion, (1) to edit,
          redact, or otherwise change any Contributions; (2) to recategorize any
          Contributions to place them in more appropriate locations in the
          Licensed Application; and (3) to prescreen or delete any Contributions
          at any time and for any reason, without notice. We have no obligation
          to monitor your Contributions.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>8. LIABILITY</strong>
        </Heading>
        <Text mb={4}>
          8.1 Licensor takes no accountability or responsibility for any damages
          caused due to a breach of duties according to Section 2 of this
          License Agreement. To avoid data loss, You are required to make use of
          backup functions of the Licensed Application to the extent allowed by
          applicable third-party terms and conditions of use. You are aware that
          in case of alterations or manipulations of the Licensed Application,
          You will not have access to the Licensed Application.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>9. WARRANTY</strong>
        </Heading>
        <Text mb={4}>
          9.1 Licensor warrants that the Licensed Application is free of
          spyware, trojan horses, viruses, or any other malware at the time of
          Your download. Licensor warrants that the Licensed Application works
          as described in the user documentation.
        </Text>
        <Text mb={4}>
          9.2 No warranty is provided for the Licensed Application that is not
          executable on the device, that has been unauthorizedly modified,
          handled inappropriately or culpably, combined or installed with
          inappropriate hardware or software, used with inappropriate
          accessories, regardless if by Yourself or by third parties, or if
          there are any other reasons outside of Redwing Tech Ltd&#39;s sphere
          of influence that affect the executability of the Licensed
          Application.
        </Text>
        <Text mb={4}>
          9.3 You are required to inspect the Licensed Application immediately
          after installing it and notify Redwing Tech Ltd about issues
          discovered without delay by email provided in{" "}
          <Link href="#productclaims" color="blue.500">
            Product Claims
          </Link>
          . The defect report will be taken into consideration and further
          investigated if it has been emailed within a period of thirty (30)
          days after discovery.
        </Text>
        <Text mb={4}>
          9.4 If we confirm that the Licensed Application is defective, Redwing
          Tech Ltd reserves a choice to remedy the situation either by means of
          solving the defect or substitute delivery.
        </Text>
        <Text mb={4}>
          9.5 In the event of any failure of the Licensed Application to conform
          to any applicable warranty, You may notify the Services Store
          Operator, and Your Licensed Application purchase price will be
          refunded to You. To the maximum extent permitted by applicable law,
          the Services Store Operator will have no other warranty obligation
          whatsoever with respect to the Licensed Application, and any other
          losses, claims, damages, liabilities, expenses, and costs attributable
          to any negligence to adhere to any warranty.
        </Text>
        <Text mb={4}>
          9.6 If the user is an entrepreneur, any claim based on faults expires
          after a statutory period of limitation amounting to twelve (12) months
          after the Licensed Application was made available to the user. The
          statutory periods of limitation given by law apply for users who are
          consumers.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>10. PRODUCT CLAIMS</strong>
        </Heading>
        <Text mb={4}>
          Redwing Tech Ltd and the End-User acknowledge that Redwing Tech Ltd,
          and not the Services, is responsible for addressing any claims of the
          End-User or any third party relating to the Licensed Application or
          the End-User's possession and/or use of that Licensed Application,
          including, but not limited to:
        </Text>
        <Text mb={4}>(i) product liability claims;</Text>
        <Text mb={4}>
          (ii) any claim that the Licensed Application fails to conform to any
          applicable legal or regulatory requirement; and
        </Text>
        <Text mb={4}>
          (iii) claims arising under consumer protection, privacy, or similar
          legislation, including in connection with Your Licensed Application's
          use of the HealthKit and HomeKit.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>11. LEGAL COMPLIANCE</strong>
        </Heading>
        <Text mb={4}>
          You represent and warrant that You are not located in a country that
          is subject to a US Government embargo, or that has been designated by
          the US Government as a &quot;terrorist supporting&quot; country; and
          that You are not listed on any US Government list of prohibited or
          restricted parties.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>12. CONTACT INFORMATION</strong>
        </Heading>
        <Text mb={4}>
          For general inquiries, complaints, questions or claims concerning the
          Licensed Application, please contact:
        </Text>
        <Text mb={2}>Thomas Quiroga</Text>
        <Text mb={2}>32 Christiemiller avenue</Text>
        <Text mb={2}>Edinburgh, Scotland EH7 6ST</Text>
        <Text mb={2}>Scotland</Text>
        <Text mb={4}>thomas@redwing.app</Text>
        <Heading as="h2" mb={4}>
          <strong>13. TERMINATION</strong>
        </Heading>
        <Text mb={4}>
          The license is valid until terminated by Redwing Tech Ltd or by You.
          Your rights under this license will terminate automatically and
          without notice from Redwing Tech Ltd if You fail to adhere to any
          term(s) of this license. Upon License termination, You shall stop all
          use of the Licensed Application, and destroy all copies, full or
          partial, of the Licensed Application.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>14. THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY</strong>
        </Heading>
        <Text mb={4}>
          Redwing Tech Ltd represents and warrants that Redwing Tech Ltd will
          comply with applicable third-party terms of agreement when using
          Licensed Application.
        </Text>
        <Text mb={4}>
          In Accordance with Section 9 of the &quot;Instructions for Minimum
          Terms of Developer's End-User License Agreement,&quot; both Apple and
          Google and their subsidiaries shall be third-party beneficiaries of
          this End User License Agreement and — upon Your acceptance of the
          terms and conditions of this License Agreement, both Apple and Google
          will have the right (and will be deemed to have accepted the right) to
          enforce this End User License Agreement against You as a third-party
          beneficiary thereof.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>15. INTELLECTUAL PROPERTY RIGHTS</strong>
        </Heading>
        <Text mb={4}>
          Redwing Tech Ltd and the End-User acknowledge that, in the event of
          any third-party claim that the Licensed Application or the End-User's
          possession and use of that Licensed Application infringes on the third
          party's intellectual property rights, Redwing Tech Ltd, and not the
          Services, will be solely responsible for the investigation, defense,
          settlement, and discharge or any such intellectual property
          infringement claims.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>16. APPLICABLE LAW</strong>
        </Heading>
        <Text mb={4}>
          This License Agreement is governed by the laws of the United Kingdom
          excluding its conflicts of law rules.
        </Text>
        <Heading as="h2" mb={4}>
          <strong>17. MISCELLANEOUS</strong>
        </Heading>
        <Text mb={4}>
          17.1 If any of the terms of this agreement should be or become
          invalid, the validity of the remaining provisions shall not be
          affected. Invalid terms will be replaced by valid ones formulated in a
          way that will achieve the primary purpose.
        </Text>
        <Text mb={4}>
          17.2 Collateral agreements, changes and amendments are only valid if
          laid down in writing. The preceding clause can only be waived in
          writing.
        </Text>
      </Box>
    </Container>
  );
};

export default Eula;
